import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d299328"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tour-select" }
const _hoisted_2 = { class: "heading" }
const _hoisted_3 = { class: "count" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "description" }
const _hoisted_6 = {
  key: 2,
  class: "container-buttons"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 登録する ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 修正する ")
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 確認画面へ ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeaderWithCloseButton = _resolveComponent("TheHeaderWithCloseButton")!
  const _component_TourSelectStepASelect = _resolveComponent("TourSelectStepASelect")!
  const _component_TourSelectStepBConfirm = _resolveComponent("TourSelectStepBConfirm")!
  const _component_AppButtonPrimary = _resolveComponent("AppButtonPrimary")!
  const _component_AppButtonSecondary = _resolveComponent("AppButtonSecondary")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TheHeaderWithCloseButton, { onClose: _ctx.close }, null, 8, ["onClose"]),
    _createElementVNode("main", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_ctx.padWithZero(_ctx.currentStepIndex + 1)), 1),
          _createTextVNode(" / " + _toDisplayString(_ctx.padWithZero(_ctx.totalSteps)), 1)
        ]),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.currentHeadingTitle), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.currentHeadingDescription), 1)
      ]),
      (_ctx.isTourSelectStepASelect)
        ? (_openBlock(), _createBlock(_component_TourSelectStepASelect, {
            key: 0,
            "tour-options": _ctx.tourOptionsComputed,
            onSelect: _ctx.selectTour
          }, null, 8, ["tour-options", "onSelect"]))
        : _createCommentVNode("", true),
      (_ctx.isTourSelectStepBConfirm)
        ? (_openBlock(), _createBlock(_component_TourSelectStepBConfirm, {
            key: 1,
            "tour-options": _ctx.tourOptionsComputed
          }, null, 8, ["tour-options"]))
        : _createCommentVNode("", true),
      (_ctx.isTourSelectStepBConfirm)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_AppButtonPrimary, { onButton: _ctx.next }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["onButton"]),
            _createVNode(_component_AppButtonSecondary, { onButton: _ctx.previous }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["onButton"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isTourSelectStepASelect)
      ? (_openBlock(), _createElementBlock("footer", _hoisted_9, [
          _createVNode(_component_AppButtonPrimary, {
            active: _ctx.isFormValid,
            onButton: _ctx.next
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["active", "onButton"])
        ]))
      : _createCommentVNode("", true)
  ]))
}